/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_MINIMUM_USAGE_TYPES } from 'src/actions/minimumUsageTypeActions';

const initialState = {
  types: []
};

const minimumUsageTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MINIMUM_USAGE_TYPES: {
      const { types } = action.payload;

      return produce(state, (draft) => {
        draft.types = types;
      });
    }

    default: {
      return state;
    }
  }
};

export default minimumUsageTypeReducer;
